import React, { Component } from "react";

import { connect } from "react-redux";
import { Header, Icon } from "semantic-ui-react";
class Authoritay extends Component {
  componentWillReceiveProps(nextProps) {
    console.log("stuff");
    if (nextProps.location.pathname != this.props.location.pathname) {
      this.props.datapop(null, "AccessRenewel");
    }
  }

  render() {
    return (
      <div className="Authoritay">
        <Header as="h1">
          <Icon name="frown" /> You are not authorized to view this Page
        </Header>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showModal: state.modal === "loading"
  };
}
export default connect(mapStateToProps)(Authoritay);



// WEBPACK FOOTER //
// ./src/components/shared-components/Nope.js